import { BusinessCardStack } from './business-card-stack';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { GenericBusinessCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/business-cards-2x3/generic-business-card-stack-background/generic-business-card-stack-background.component';
import { GenericBusinessCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/business-cards-2x3/generic-business-card-stack-content/generic-business-card-stack-content.component';
import type { GenericCardData } from '../../../../print-cards/generic-card-data';

export class GenericBusinessCardStack extends BusinessCardStack {
  getCardBackgroundComponent(cardData: GenericCardData): Type<CardBackgroundComponent> {
    return GenericBusinessCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: GenericCardData): Type<PrintCardContentComponent> {
    return GenericBusinessCardStackContentComponent;
  }
}
